module.exports = __webpack_public_path__ + "img/ELearningRightBanner.bb955ce5.png";